/**
 * 岗位能力评估 雷达图组件
 * @author Ariel
 * @date 2020-7-13
 */
import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom'
import '@/styles/components/exam/examPreviw/index.less'
import { component_tool } from '../../tool'

let {
  WizComponent,
  WizRow,
  WizBizcharts,
  WizDataSet,
} = component_tool;
let {
  Chart,
  Geom,
  Axis,
  Tooltip,
  Coord,
  Legend,
  Label
} = WizBizcharts
export default class PositionRadar extends WizComponent {

  constructor(props) {
    super(props);
    this.state = {}
  }

  componentDidMount() {
    let { radarProps } = this.props;
    this._renderRader(radarProps);
  }

  componentWillUnmount() {
  }

  /**
   * 渲染radar
   */
  _renderRader = ({ data, dataFormat, cols, colors }) => {
    const Util = G2.Util;
    const theme = Util.deepMix({
      colors: colors || ['#8B8B83', '#00BFFF', '#FF0000']
    }, G2.Theme)
    G2.Global.setTheme(theme)

    const { DataView } = WizDataSet
    const dv = new DataView()
    dv.source(data).transform(dataFormat);
    let o = document.getElementById("_content");
    let{ height=600,width=628,stroke='#fff' } = this.props
    ReactDOM.render((
      <Chart
        width={width}
        height={height}
        data={dv}
        scale={cols}
      >
        <Coord type={"polar"} radius={0.75} />
        <Axis
          name="item"   //当前坐标轴对应数据源中的字段名（必填）
          line={null}   //坐标轴线
          tickLine={null} //刻度线
          grid={{       //网格
            lineStyle: {
              stroke: stroke,
              lineDash: null
            },
            hideFirstLine: false,
          }}
          label={{
            formatter: (val, item, index) => {
              let strs = val.split('');
              let str = ''
              for (let i = 0, s; s = strs[i++];) {
                str += s;
                if (!(i % 4) && i !== val.length) str += '\n';
              }
              return str
            },
          }}
        />
        <Tooltip />
        <Axis
          name="score"
          line={null}
          tickLine={null}
          grid={{
            type: 'polygon',
            lineStyle: {
              lineDash: null,
            },
          }}
        />
        <Legend />
        <Geom
          type="line"
          position="item*score"
          color="user"
          size={2}>
        </Geom>
        <Geom                   //几何标记对象，决定创建图表的类型
          type="point"          //几何标记类型 point：点
          position="item*score" //位置属性的映射，即确定 x 轴和 y 轴的数据字段。
          color='user'
          shape="circle"        //将数据值映射到图形的形状上的方法
          size={2}
          style={{
            stroke: stroke,
            lineWidth: 1,
            fillOpacity: 1,
          }}
          tooltip={['item*score', (item, score) => {
            return {
              name: item,
              value: score
            }
          }]}
        >
        </Geom>
      </Chart>
    ), document.getElementById(this.props.radarKey || 'radar'));
  }


  /**
   * 主体部分：统计图表
   */
  _content = () => {
    return (
      <WizRow id={'_content'} type={'flex'} align={'middle'}>
        <div id={this.props.radarKey || 'radar'}></div>
      </WizRow>
    )
  }

  render() {
    return (
      <div style={{ border: '2px solid #E7E7E7', borderRadius: 8, display: 'flex', justifyContent: 'center', flexDirection: 'column', marginLeft: 10 }} {...this.props.other} >
        <h2 className='position-radar-title'>{this.props.radarName}</h2>
        {this._content()}
      </div>
    )

  }
}

/**
 * 默认值
 */
PositionRadar.defaultProps = {
  other: {},
  radarProps: {
    data: [],
    dataFormat: {},
    cols: {}
  }
}

/**
 * props入参校验
 */
PositionRadar.propTypes = {
  /**
   * radar的参数
   */
  radarProps: PropTypes.obj,
}
